import {Modal} from '@/components-v2/organisms'
import {SegmentTypes} from '@/utils/constants/promotionConstants'
import {useEffect, useMemo, useState} from 'react'
import {SegmentFolderContent} from './SegmentFolderContent'
import {SegmentModalListContent} from './SegmentModalListContent'
// import './segmentModal.scss'

/**
 * @typedef {import('@/types/promotionTypes').SegmentDetails} SegmentDetails
 */

/**
 * Segment selection modal.
 * @param {{
 * show: boolean,
 * type: string,
 * groupIndex: number | null,
 * onClose: Function,
 * onSubmit: Function,
 * existingSelections: SegmentDetails[]
 * }} props
 */
export const SegmentModal = ({show, type, groupIndex, onClose, onSubmit, existingSelections}) => {
  const [selectedSegments, setSelectedSegments] = useState(existingSelections)

  useEffect(() => {
    setSelectedSegments(existingSelections)
  }, [existingSelections])

  const modalTitle = useMemo(() => {
    switch (type) {
      case SegmentTypes.SEGMENT_FOLDER:
        return 'Segment'
      case SegmentTypes.SEGMENT_LIST:
        return 'Segments'
      default:
        return ''
    }
  }, [type])

  const modalText = useMemo(() => {
    switch (type) {
      case SegmentTypes.SEGMENT_FOLDER:
        return 'Segment Folder'
      case SegmentTypes.SEGMENT_LIST:
        return 'Segment List'
      default:
        return ''
    }
  }, [type])

  const renderContent = useMemo(() => {
    if (type === SegmentTypes.SEGMENT_FOLDER) {
      return <SegmentFolderContent selectedSegments={selectedSegments} setSelectedSegments={setSelectedSegments} />
    }

    return <SegmentModalListContent selectedSegments={selectedSegments} setSelectedSegments={setSelectedSegments} />
  }, [type, selectedSegments])

  return (
    <Modal
      showModal={show}
      onCloseModal={onClose}
      showTertiaryButton={true}
      tertiaryButtonProps={{text: 'Cancel', onClick: onClose}}
      showPrimaryButton={true}
      primaryButtonProps={{
        text: 'Apply',
        onClick: () => {
          onSubmit(selectedSegments, groupIndex, type)
          onClose()
        },
      }}
      title={modalTitle}
      text={modalText}
      showSlot={true}
      type="L"
      hideCloseButton={true}
    >
      {renderContent}
    </Modal>
  )
}
